import type { NavigationGuardWithThis } from 'vue-router'
import { useRegelgruppenStore } from '@/stores/regelgruppen/RegelgruppenStore'
import { usePatientenProfileStore } from '@/stores/patientenprofile/PatientenprofileStore'
import { useRegelnStore } from '@/stores/regeln/RegelnStore'
import { useFaecherAndFocusStore } from '@/stores/FaecherAndFocusStore'

export const regelgruppenBeforeEnter: NavigationGuardWithThis<undefined> = async (
  to,
  _from,
  next
) => {
  const regelgruppenStore = useRegelgruppenStore()
  const patientenProfilStore = usePatientenProfileStore()
  const regelStore = useRegelnStore()
  const faecherStore = useFaecherAndFocusStore()

  const regelgruppenId = to.params.regelgruppenId || undefined
  const patientenProfilId = to.params.patientenProfilId || undefined
  const regelId = to.params.regelId || undefined
  const undefinedStringToUndefined = (str: string) => (str === 'undefined' ? undefined : str)

  const loadRegelgruppe = () => {
    if (typeof regelgruppenId === 'string')
      return regelgruppenStore.selectRegelgruppe(undefinedStringToUndefined(regelgruppenId))
  }
  const loadPatientenProfil = () => {
    if (typeof patientenProfilId === 'string')
      return patientenProfilStore.selectPatientenProfile(
        undefinedStringToUndefined(patientenProfilId)
      )
  }
  const loadRegel = () => {
    if (typeof regelId === 'string')
      return regelStore.selectRegel(undefinedStringToUndefined(regelId))
  }

  if (to.path.includes('regeln')) faecherStore.changeIndex(3, true)
  else if (to.path.includes('patientenprofil')) faecherStore.changeIndex(2, true)
  else faecherStore.changeIndex(1, true)

  const promises: Promise<unknown>[] = []

  if ((regelgruppenStore.selectedItem?.id || undefined) !== regelgruppenId) {
    const regelgruppePromise = loadRegelgruppe()
    if (regelgruppePromise) promises.push(regelgruppePromise)
    promises.push(regelgruppenStore.getRegelgruppenNames())
  }
  if ((patientenProfilStore.selectedItem?.id || undefined) !== patientenProfilId) {
    const patientenProfilPromise = loadPatientenProfil()
    if (patientenProfilPromise) promises.push(patientenProfilPromise)
  }
  if ((regelStore.selectedItem?.id || undefined) !== regelId) {
    const regelPromise = loadRegel()
    if (regelPromise) promises.push(regelPromise)
  }

  await Promise.all(promises)

  next()
}
